import persianNumberFormat from "../../../helper/PersianNumberFormat";

export function StackedChart(statistics, object, master, child, value) {

  const categories = [...new Set(statistics[object].map(item => item[master]))];
  const seriesNames = [...new Set(statistics[object].map(item => item[child]))];
  const series = seriesNames.map(seriesName => ({
    name: seriesName,
    data: categories.map(category => {
      const record = statistics[object].find(item => item[master] === category && item[child] === seriesName);
      return record ? record[value] : 0;
    })
  }));

  const categoriesShow = [...new Set(statistics[object].map(item => persianNumberFormat(item[master])))];

  return {
    type: "bar",
    height: 250,
    series: series,
    colors: ['#fff', '#fff'],
    options: {
      chart: {
        type: 'bar',
        background: '#fff',
        stacked: true,
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '16%',
          endingShape: 'rounded',
          borderRadius: 5,
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (value, {seriesIndex, dataPointIndex, w}) {
          return w.config.series[seriesIndex].name
        },
        textAnchor: 'middle',
        distributed: false,
        offsetX: 0,
        offsetY: 0,
        background: {
          enabled: true,
          foreColor: 'blue-gray',
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: categoriesShow,
      },
      yaxis: {
        labels: {
          formatter: (val) => {
            return persianNumberFormat(val, true)
          },
        },
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        theme: "dark",
        y: {
          formatter: function (val) {
            return persianNumberFormat(val, true)
          }
        },
      },
      grid: {
        show: true,
        borderColor: "#dddddd",
        strokeDashArray: 5,
        xaxis: {
          lines: {
            show: false,
          },
        },
        padding: {
          top: 5,
          right: 10,
        },
      },
    },


  }
}

export default StackedChart;
